import { render } from "./PersonList.vue?vue&type=template&id=145dac37&scoped=true"
import script from "./PersonList.vue?vue&type=script&lang=js"
export * from "./PersonList.vue?vue&type=script&lang=js"

import "./PersonList.vue?vue&type=style&index=0&id=145dac37&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145dac37"]])

export default __exports__